import { Mail, MapPin } from "lucide-react";

export default function Contact() {
  return (
    <div className="max-w-[1100px] mx-auto px-5 md:px-10 py-16 md:py-24">
      <div className="max-w-3xl">
        <div className="ie-overline text-brand-accent mb-4">
          Care
        </div>

        <h1 className="font-serif text-5xl md:text-7xl tracking-tight leading-[1.05]">
          Contact
        </h1>

        <p className="text-text-secondary text-base md:text-lg leading-relaxed mt-6">
          Questions about an order, sizing, delivery or anything else?
          Our care team is here to help.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-8 mt-16">
        <div className="border border-border p-7 md:p-10">
          <Mail className="w-5 h-5 mb-6" />

          <div className="ie-overline text-brand-accent mb-3">
            Email
          </div>

          <h2 className="font-serif text-2xl mb-3">
            Customer Care
          </h2>

          <a
            href="mailto:care@induseirene.in"
            className="text-text-secondary hover:text-foreground transition-colors"
          >
            care@induseirene.in
          </a>
        </div>

        <div className="border border-border p-7 md:p-10">
          <MapPin className="w-5 h-5 mb-6" />

          <div className="ie-overline text-brand-accent mb-3">
            Atelier
          </div>

          <h2 className="font-serif text-2xl mb-3">
            Madhya Pradesh
          </h2>

          <p className="text-text-secondary">
            India
          </p>
        </div>
      </div>

      <div className="border-t border-border mt-16 pt-8">
        <p className="text-xs text-text-secondary leading-6">
          For order-related questions, please include your order number so
          that our care team can assist you faster.
        </p>
      </div>
    </div>
  );
}